import * as React from 'react';
import { Button } from 'antd'

export const GrtSplitTest = (
    { children, style, clickCumBtnText, ...otherProps }
) => {

    const split = () => {
        const { componentId } = otherProps;
        const currentDocument = parent.AliLowCodeEngine.project.currentDocument;
        const currentNode = currentDocument.getNodeById(componentId);
        const newNode = currentDocument.createNode({
            ...(currentNode.exportSchema()),
            children: []
        })
        currentNode.parent.insertAfter(newNode)
        newNode.select()

    }

    // React.useEffect(() => {

    //     Event.on('globalConfigChanged', () => {
    //         console.log('我要修改自己组件的内容')
    //     })
    // }, [])

    return (
        <div style={style}>
            <div>{clickCumBtnText}</div>
            {children}
            <Button onClick={split} style={{
                position: 'absolute',
                top: 0,
                left: '48vw'
            }}> 点我切割</Button>
        </div>
    );
};

